/**
 * 環境別ログ管理
 */

// type LogLevel = 'debug' | 'info' | 'warn' | 'error';

const isDevelopment = (typeof process !== 'undefined' ? process.env.NODE_ENV : 'development') === 'development';

// エラー監視サービスとの統合のため遅延インポート
let errorMonitoring: typeof import('./error-monitoring').errorMonitoring | null = null;

const getErrorMonitoring = async (): Promise<typeof import('./error-monitoring').errorMonitoring> => {
  if (!errorMonitoring) {
    const module = await import('./error-monitoring');
    errorMonitoring = module.errorMonitoring;
  }
  return errorMonitoring;
};

/**
 * 開発環境でのみログを出力
 */
export const logger = {
  debug: (message: string, ...args: unknown[]): void => {
    if (isDevelopment) {
      console.log(`🔍 ${message}`, ...args);
    }
  },
  
  info: (message: string, ...args: unknown[]): void => {
    if (isDevelopment) {
      console.info(`ℹ️ ${message}`, ...args);
    }
  },
  
  warn: (message: string, ...args: unknown[]): void => {
    if (isDevelopment) {
      console.warn(`⚠️ ${message}`, ...args);
    }
  },
  
  error: (message: string, ...args: unknown[]): void => {
    // エラーは本番環境でも出力
    console.error(`❌ ${message}`, ...args);
  },
  
  navigation: (message: string, data?: Record<string, unknown>): void => {
    if (isDevelopment) {
      console.log(`🎯 Navigation: ${message}`, data);
    }
    
    // エラー監視サービスにナビゲーションのパンくずを追加
    getErrorMonitoring().then(monitoring => {
      monitoring.addBreadcrumb(message, 'navigation', 'info');
    }).catch(() => {
      // エラー監視サービスの読み込みに失敗した場合は無視
    });
  }
};